import React from "react";
import SEO from "@/components/SEO";
import { siteConfig } from "@/config/siteConfig";

const CookiePolicy = () => (
  <>
    <SEO
      title="Cookie Policy"
      description={`How ${siteConfig.COMPANY_NAME} uses cookies on this website, categories set, and how to change your preferences.`}
      path="/cookie-policy"
    />
    <article className="mx-auto max-w-3xl px-6 lg:px-10 py-16 lg:py-24 legal-doc" data-testid="cookie-policy-page">
      <h1 className="font-heading text-4xl sm:text-5xl font-semibold text-[var(--navy)] tracking-tight">
        Cookie Policy
      </h1>
      <p className="mt-3 text-sm text-[var(--slate)]">
        Last updated: {siteConfig.CURRENT_YEAR}
      </p>

      <p className="mt-8">
        This Cookie Policy explains how <strong>{siteConfig.COMPANY_NAME}</strong> uses cookies and similar
        technologies on this website. It should be read together with our <a href="/privacy-policy">Privacy Policy</a>.
      </p>

      <h2>1. What are cookies?</h2>
      <p>
        Cookies are small text files placed on your device when you visit a website. They allow the website to
        function, remember your preferences, and help understand how the site is used.
      </p>

      <h2>2. Categories of cookies we use</h2>

      <h3>Strictly necessary</h3>
      <p>
        These cookies are required for the Site to function correctly (for example, to remember your cookie choice
        so we do not ask you again on every page). They cannot be switched off. No personal data collected via these
        cookies is used for advertising.
      </p>

      <h3>Analytics (optional, consent-based)</h3>
      <p>
        With your explicit consent, we may load Google Analytics and/or Google Tag Manager scripts to understand
        aggregate visitor behaviour (pages visited, session duration, referrers). These scripts are only loaded if
        you accept the “Analytics” category — otherwise no analytics cookies are set. If you have not consented,
        these scripts are not loaded at all.
      </p>

      <h2>3. Managing your preferences</h2>
      <p>
        On your first visit you are shown a cookie banner with the options <em>Accept all</em>,
        <em> Reject non-essential</em>, and <em>Preferences</em>. You can change your choice at any time via the
        <strong> “Manage cookies”</strong> link in the footer, which re-opens the preferences panel. Your choice is
        stored locally on your device.
      </p>

      <h2>4. Browser controls</h2>
      <p>
        Most browsers allow you to view, delete and block cookies through their settings. Please refer to your
        browser’s help documentation. Note that disabling strictly necessary cookies may cause parts of the Site to
        stop working correctly.
      </p>

      <h2>5. Do Not Track</h2>
      <p>
        We currently do not respond to browser “Do Not Track” signals, but analytics scripts are only loaded on
        explicit opt-in as described above.
      </p>

      <h2>6. Changes to this policy</h2>
      <p>
        We may update this Cookie Policy from time to time. Any changes will be posted on this page with an updated
        “last updated” date.
      </p>

      <h2>7. Contact</h2>
      <p>
        Questions about this Cookie Policy can be sent to <strong>{siteConfig.EMAIL_SALES}</strong>.
      </p>
    </article>
  </>
);

export default CookiePolicy;
